import type {
  FilterKey,
  FiltersActive,
  OptionalFilter
} from '@library/types/filters';
import { useState } from 'react';

export function useLeagueDependentFiltersActive<T extends OptionalFilter>({
  filters
}: {
  filters: T;
}) {
  const defaultFiltersActive: FiltersActive = Object.fromEntries(
    Object.entries(filters).map(([key]) => [key, true])
  );

  const [activeFilters, setActiveFilters] = useState(defaultFiltersActive);

  const changeFilterActive = (filterKey: FilterKey, value: boolean) => {
    const newFilterState = {
      ...activeFilters,
      [filterKey]: value
    };

    setActiveFilters(newFilterState);
  };

  return {
    changeFilterActive,
    activeFilters,
    setActiveFilters
  };
}
